import React from "react";
import PropTypes from "prop-types";
import OvInfoCard from "./OvInfoCard";
import OvAccountsInfoContent from "./OvAccountsInfoContent";
import OvAccountsInfoActionsContainer from "./OvAccountsInfoActionsContainer";
import OvAccountsInfoTable from "./OvAccountsInfoTable";

const OvAccountsInfoCard = props => {
  const { filterState } = props;

  const data = props.data.filter(
    d =>
      d.instance_cost > 0 || d.license_cost > 0 || d.storage_cost || d.minutes > 0 || d.cores > 0|| d.storage > 0
  );

  return (
    <div style={{ display: props.monitoringMode ? "none" : "block" }}>
      <OvInfoCard
        loading={props.loading}
        title="Usage by account"
        content={
          <OvAccountsInfoContent data={data} filterState={filterState} />
        }
        actions={<OvAccountsInfoActionsContainer {...props}/>}
        expandedContent={<OvAccountsInfoTable data={data} />}
        expandLabel="Table"
        contractLabel="Hide table"
      />
    </div>
  );
};

OvAccountsInfoCard.propTypes = {
  data: PropTypes.array.isRequired,
  filterState: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default OvAccountsInfoCard;



// WEBPACK FOOTER //
// ./src/OvAccountsInfoCard.js